<div class="container">
  <h1>Membros</h1>
  @if (condominium) {
    <h3>Síndico: {{ condominium.owner?.username }}</h3>
  }

  <table mat-table [dataSource]="members" class="mat-elevation-z2 full-width">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nome </th>
      <td mat-cell *matCellDef="let member"> {{ member.name }} </td>
    </ng-container>

    @if (isOwner) {
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef> E-mail </th>
        <td mat-cell *matCellDef="let member"> {{ member.email }} </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="isOwner ? displayedColumnsOwner : displayedColumnsMember"></tr>
    <tr mat-row *matRowDef="let row; columns: isOwner ? displayedColumnsOwner : displayedColumnsMember;"></tr>
  </table>
</div>


